<template>
  <div>
    <maintenance v-if="maintenances.length > 0"/>
    <div v-else>
      <blank
        :src="`/static/icons/blank/maintenance.png`"
        :firstLine="`Bảo trì - bảo dưỡng`"
        :secondLine="`Tạo các lịch bảo trì cho xe. Hệ thống sẽ nhắc nhở và ghi nhận việc bảo trì định kỳ`"
        :width="360"
        :showButton="true"
        :onClick="create"
      />
    </div>
    <div class="text-xs-center">
      <v-dialog v-model="addDialog" width="480" persistent>
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Tạo lịch bảo trì</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="addDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <add @show="addDialog = $event"/>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Maintenance from './components/Grid';
import Add from './components/Add';
import Blank from '@/components/Blank';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    Maintenance,
    Blank,
    Add
  },
  data () {
    return {
      addDialog: false
    };
  },
  computed: {
    ...mapGetters(['maintenances'])
  },
  created () {
    this.getMaintenances();
  },
  methods: {
    ...mapActions(['getMaintenances']),
    create () {
      this.addDialog = true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/maintenance/index.vue